import { type ReactElement } from 'react'
import { ErrorBox } from '../ErrorBox'
import { ChargeError } from '../ChargeError'

interface PaymentErrorProps {
  error: string
  errorCode?: { description: string, merchantAction: string } | null | undefined
  errorMessage?: string | null | undefined
  handleClearErrors: () => void
}

export function PaymentError ({ error, errorCode, errorMessage, handleClearErrors }: PaymentErrorProps): ReactElement {
  return (
    <>
      <div className="fixed z-30 block top-0 left-0 w-full h-full bg-gray-700 opacity-60" />
      <div className="w-full h-screen flex justify-center items-center fixed inset-0 z-40" onClick={handleClearErrors}>
        <div className="absolute w-96 z-50">
          {errorCode ? <ChargeError error={error} errorCode={errorCode} /> : <ErrorBox error={error} errorMessage={errorMessage} />}
        </div>
      </div>
    </>
  )
}
